import SaveProfileContractDto from '../../dto/profiles/in/save-profile-contract.dto';
import { apiV1 } from '../../http';
import { axiosHttpErrorToError } from '../../utils/errors';

class SaveProfileContractService {
  async save(id: string, dto: SaveProfileContractDto): Promise<void> {
    try {
      await apiV1.put<void>(`/profiles/${id}/contract`, dto);
    } catch (error) {
      throw axiosHttpErrorToError(error);
    }
  }
}

export default SaveProfileContractService;
